import { render, staticRenderFns } from "./TermsHub.vue?vue&type=template&id=35e55b6c&scoped=true"
import script from "./TermsHub.vue?vue&type=script&lang=js"
export * from "./TermsHub.vue?vue&type=script&lang=js"
import style0 from "./TermsHub.vue?vue&type=style&index=0&id=35e55b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e55b6c",
  null
  
)

export default component.exports